import { createFileRoute } from '@tanstack/react-router';

import { OrdersView } from '@/modules/orders/views/OrdersView';

export const Route = createFileRoute('/_app/orders/')({
   component: OrdersView
});
